import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useNavigate } from 'react-router-dom';

export function MenuDropDown({title,id, runningId}) {
  const navigate = useNavigate();

  const handlePage = (page,runningId)=> {
    setTimeout(() => {
      navigate(page, { state:{runningId:runningId}, replace: true });
      navigate(0);
    }, 100);
  }

    return (
    <>
        <DropdownButton id="dropdown-basic-button" title={title} variant="transparent" class="m-0 p-0 pe-3 border-0">
            <Dropdown.Item onClick={()=>handlePage('/home.html',runningId)} disabled={title==='Home'?'true':undefined}>Home</Dropdown.Item>
            <Dropdown.Divider/>
            <Dropdown.Item onClick={()=>handlePage('/clientdetails.html',runningId)} disabled={title==='Client Details'?'true':undefined}>Client Details</Dropdown.Item>
            <Dropdown.Item onClick={()=>handlePage('/rulingPlanet.html',runningId)} disabled={title==='Ruling Planet'?'true':undefined}>Ruling Planet</Dropdown.Item>
            <Dropdown.Divider/>
            <Dropdown.Item onClick={()=>handlePage('/basicastro.html',runningId)} disabled={title==='Vedic Astrology'?'true':undefined}>Vedic Astrology</Dropdown.Item>
            <Dropdown.Item onClick={()=>handlePage('/kpastro.html',runningId)} disabled={title==='KP System'?'disabled':undefined}>KP System</Dropdown.Item>
            <Dropdown.Item onClick={()=>handlePage('/kpinterlinks.html',runningId)} disabled={title==='Cuspal Inter Link System'?'disabled':undefined}>Cuspal Inter Link System</Dropdown.Item>
            <Dropdown.Item onClick={()=>handlePage('/events.html',runningId)} disabled={title==='Advanced Stellar System'?'disabled':undefined} >Advanced Stellar System</Dropdown.Item>
            <Dropdown.Divider/>
            <Dropdown.Item onClick={()=>handlePage('/transitchart.html',runningId)} disabled={title==='Transit Chart'?'disabled':undefined}>Transit Chart</Dropdown.Item>
            <Dropdown.Item onClick={()=>handlePage('/timecorrection.html',runningId)} disabled={title==='Birth Time Correction'?'disabled':undefined}>Birth Time Correction</Dropdown.Item>
            <Dropdown.Divider/>
            <Dropdown.Item onClick={()=>handlePage('/editclient.html',runningId)} disabled={title==='Edit Details'?'disabled':undefined} >Edit Details</Dropdown.Item>
            <Dropdown.Item onClick={()=>handlePage('/ccconfig.html',runningId)} disabled={title==='Settings'?'disabled':undefined} >Settings</Dropdown.Item>
            <Dropdown.Divider/>
            <Dropdown.Item onClick={()=>handlePage('/deleteclient.html',runningId)} disabled={title==='Delete'?'disabled':undefined}>Delete</Dropdown.Item>
        </DropdownButton>
    </>
    );
}